var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 149,
    height: 138,
    viewBox: "0 0 149 138",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.1665,
    cy: 20.1001,
    r: 2.1665,
    fill: "url(#paint0_linear_356_3945)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 88.9673,
    cy: 20.1001,
    r: 2.1665,
    fill: "url(#paint1_linear_356_3945)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.1001,
    cy: 20.1001,
    r: 2.1665,
    fill: "url(#paint2_linear_356_3945)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 117.901,
    cy: 20.1001,
    r: 2.1665,
    fill: "url(#paint3_linear_356_3945)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.0337,
    cy: 20.1001,
    r: 2.1665,
    fill: "url(#paint4_linear_356_3945)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 146.834,
    cy: 20.1001,
    r: 2.1665,
    fill: "url(#paint5_linear_356_3945)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.1665,
    cy: 49.0337,
    r: 2.1665,
    fill: "url(#paint6_linear_356_3945)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 88.9673,
    cy: 49.0337,
    r: 2.1665,
    fill: "url(#paint7_linear_356_3945)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.1001,
    cy: 49.0337,
    r: 2.1665,
    fill: "url(#paint8_linear_356_3945)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 117.901,
    cy: 49.0337,
    r: 2.1665,
    fill: "url(#paint9_linear_356_3945)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.0337,
    cy: 49.0337,
    r: 2.1665,
    fill: "url(#paint10_linear_356_3945)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 146.834,
    cy: 49.0337,
    r: 2.1665,
    fill: "url(#paint11_linear_356_3945)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.1665,
    cy: 77.9663,
    r: 2.1665,
    fill: "url(#paint12_linear_356_3945)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 88.9673,
    cy: 77.9663,
    r: 2.1665,
    fill: "url(#paint13_linear_356_3945)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.1001,
    cy: 77.9663,
    r: 2.1665,
    fill: "url(#paint14_linear_356_3945)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_356_3945)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 31.1001,
    cy: 77.9663,
    r: 2.1665,
    fill: "url(#paint15_linear_356_3945)"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 117.901,
    cy: 77.9663,
    r: 2.1665,
    fill: "url(#paint16_linear_356_3945)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.0337,
    cy: 77.9663,
    r: 2.1665,
    fill: "url(#paint17_linear_356_3945)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 146.834,
    cy: 77.9663,
    r: 2.1665,
    fill: "url(#paint18_linear_356_3945)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.1665,
    cy: 106.9,
    r: 2.1665,
    fill: "url(#paint19_linear_356_3945)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 88.9673,
    cy: 106.9,
    r: 2.1665,
    fill: "url(#paint20_linear_356_3945)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.1001,
    cy: 106.9,
    r: 2.1665,
    fill: "url(#paint21_linear_356_3945)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 117.901,
    cy: 106.9,
    r: 2.1665,
    fill: "url(#paint22_linear_356_3945)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.0337,
    cy: 106.9,
    r: 2.1665,
    fill: "url(#paint23_linear_356_3945)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 146.834,
    cy: 106.9,
    r: 2.1665,
    fill: "url(#paint24_linear_356_3945)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.1665,
    cy: 135.833,
    r: 2.1665,
    fill: "url(#paint25_linear_356_3945)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 88.9673,
    cy: 135.833,
    r: 2.1665,
    fill: "url(#paint26_linear_356_3945)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.1001,
    cy: 135.833,
    r: 2.1665,
    fill: "url(#paint27_linear_356_3945)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 117.901,
    cy: 135.833,
    r: 2.1665,
    fill: "url(#paint28_linear_356_3945)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.0337,
    cy: 135.833,
    r: 2.1665,
    fill: "url(#paint29_linear_356_3945)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 146.834,
    cy: 135.833,
    r: 2.1665,
    fill: "url(#paint30_linear_356_3945)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_356_3945",
    x: 23.9336,
    y: 70.7998,
    width: 14.332,
    height: 14.333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_356_3945"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_356_3945",
    x1: 2.1665,
    y1: 17.9336,
    x2: 2.1665,
    y2: 22.2666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_356_3945",
    x1: 88.9673,
    y1: 17.9336,
    x2: 88.9673,
    y2: 22.2666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_356_3945",
    x1: 31.1001,
    y1: 17.9336,
    x2: 31.1001,
    y2: 22.2666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_356_3945",
    x1: 117.901,
    y1: 17.9336,
    x2: 117.901,
    y2: 22.2666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_356_3945",
    x1: 60.0337,
    y1: 17.9336,
    x2: 60.0337,
    y2: 22.2666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_356_3945",
    x1: 146.834,
    y1: 17.9336,
    x2: 146.834,
    y2: 22.2666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_356_3945",
    x1: 2.1665,
    y1: 46.8672,
    x2: 2.1665,
    y2: 51.2002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_356_3945",
    x1: 88.9673,
    y1: 46.8672,
    x2: 88.9673,
    y2: 51.2002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_356_3945",
    x1: 31.1001,
    y1: 46.8672,
    x2: 31.1001,
    y2: 51.2002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_356_3945",
    x1: 117.901,
    y1: 46.8672,
    x2: 117.901,
    y2: 51.2002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_356_3945",
    x1: 60.0337,
    y1: 46.8672,
    x2: 60.0337,
    y2: 51.2002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_356_3945",
    x1: 146.834,
    y1: 46.8672,
    x2: 146.834,
    y2: 51.2002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_356_3945",
    x1: 2.1665,
    y1: 75.7998,
    x2: 2.1665,
    y2: 80.1328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_356_3945",
    x1: 88.9673,
    y1: 75.7998,
    x2: 88.9673,
    y2: 80.1328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_356_3945",
    x1: 31.1001,
    y1: 75.7998,
    x2: 31.1001,
    y2: 80.1328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F37046"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F37046"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_356_3945",
    x1: 31.1001,
    y1: 75.7998,
    x2: 31.1001,
    y2: 80.1328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F37046"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F37046"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_356_3945",
    x1: 117.901,
    y1: 75.7998,
    x2: 117.901,
    y2: 80.1328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_356_3945",
    x1: 60.0337,
    y1: 75.7998,
    x2: 60.0337,
    y2: 80.1328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_356_3945",
    x1: 146.834,
    y1: 75.7998,
    x2: 146.834,
    y2: 80.1328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_356_3945",
    x1: 2.1665,
    y1: 104.733,
    x2: 2.1665,
    y2: 109.066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_356_3945",
    x1: 88.9673,
    y1: 104.733,
    x2: 88.9673,
    y2: 109.066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_356_3945",
    x1: 31.1001,
    y1: 104.733,
    x2: 31.1001,
    y2: 109.066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_356_3945",
    x1: 117.901,
    y1: 104.733,
    x2: 117.901,
    y2: 109.066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_356_3945",
    x1: 60.0337,
    y1: 104.733,
    x2: 60.0337,
    y2: 109.066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_356_3945",
    x1: 146.834,
    y1: 104.733,
    x2: 146.834,
    y2: 109.066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_356_3945",
    x1: 2.1665,
    y1: 133.667,
    x2: 2.1665,
    y2: 138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_356_3945",
    x1: 88.9673,
    y1: 133.667,
    x2: 88.9673,
    y2: 138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_356_3945",
    x1: 31.1001,
    y1: 133.667,
    x2: 31.1001,
    y2: 138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_356_3945",
    x1: 117.901,
    y1: 133.667,
    x2: 117.901,
    y2: 138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_356_3945",
    x1: 60.0337,
    y1: 133.667,
    x2: 60.0337,
    y2: 138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_356_3945",
    x1: 146.834,
    y1: 133.667,
    x2: 146.834,
    y2: 138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.2044c82ef267ce4f799023f8def854e2.svg";
export { ForwardRef as ReactComponent };